import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasDynamicBaseComponent } from './gas-dynamic-base.component';

const COMPONENTS = [
  GasDynamicBaseComponent,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class GasDynamicBaseModule {}
